import { Box } from '@mui/material'
import { DesignContext } from 'contexts/DesignContext'
import React, { useContext } from 'react'
import { Spinner } from 'react-bootstrap'

const LoadingApi = () => {
  const designContext = useContext(DesignContext)
  const { isLoadingApi } = designContext
  if (isLoadingApi === 'loading') {
    return (
      <Box
        position="absolute"
        style={{ width: '100%', height: '100%', background: '#0000004d' }}
        zIndex="100"
      >
        <Spinner
          animation="border"
          role="status"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
          }}
        >
          <span className="visually-hidden"></span>
        </Spinner>
      </Box>
    )
  }
  return ''
}

export default LoadingApi
